import * as Listing3 from "./Listing3";
import * as Listing6 from "./Listing6";

type T = string;

export const fromListing3 = (l: Listing3.T): T => `${l.street_name}, ${l.city_town}, ${l.postcode}`;

export const fromListing6 = (l: Listing6.T): T => `${l.street_name}, ${l.city_town}, ${l.postcode}`;
